import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Tutorial from 'components/molecules/Tutorial';
import { actionCreators as tutorialAC, getAreTutorialsLoaded, getVisibleTutorial } from 'store/tutorial';
import { TriggeredTutorialType } from 'store/tutorial';

export type StateToPropsType = {
	triggeredTutorial: TriggeredTutorialType;
	areTutorialsLoaded: boolean;
	visibleTutorial: TriggeredTutorialType;
};

const mapStateToProps = (state) => ({
	areTutorialsLoaded: getAreTutorialsLoaded(state),
	visibleTutorial: getVisibleTutorial(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doUpdateTutorialFlag: tutorialAC.doUpdateTutorialFlag,
			doTriggerTutorial: tutorialAC.doTriggerTutorial,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Tutorial as any);
